import React from 'react';

import CustomizedStatusSelect, {
    IOptionComponent,
} from 'components/common/CustomizedStatusSelect/CustomizedStatusSelect';
import { OptionValue } from 'components/common/CustomizedStatusSelect/CustomizedStatusSelect.types';
import Icon from 'components/common/Icons/base/Icon/Icon';

import { statusOptions } from 'components/widgets/RiskRegister/RiskRegister.utils';
import { useStatusCellLogic } from 'components/widgets/RiskRegister/components/StatusCell/StatusCell.logic';
import classes from 'components/widgets/RiskRegister/components/StatusCell/StatusCell.module.scss';
import { useStatusCellProvider } from 'components/widgets/RiskRegister/components/StatusCell/StatusCell.provider';

export const StatusCell = ({ status, riskId }) => {
    const { api } = useStatusCellProvider();
    const { logic } = useStatusCellLogic({ api, riskId });
    return (
        <CustomizedStatusSelect<OptionValue>
            options={statusOptions}
            optionValue={statusOptions.find((option) => option.name === status) ?? null}
            className={classes.statusCustomSelectContainer}
            optionComponent={SelectItem}
            handleChange={logic.updateStatus}
        />
    );
};

const SelectItem = ({ item, handleSelect }: IOptionComponent<OptionValue>) => {
    return (
        <div
            className={`${classes.statusCustomSelectItem} ${classes[item.name]}`}
            onClick={(e) => {
                handleSelect(item, e);
            }}
        >
            <span>{item.label}</span>
            <div data-testid={'arrow-icon'} className={classes.arrowIconWrapper}>
                <Icon name={'header-arrow-down'} size={'20'} color={'#ffffff'} />
            </div>
        </div>
    );
};
